module.exports = __webpack_public_path__ + "04_mid_black.3cdb69a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_mid_black.png
// module id = OYkI
// module chunks = 0